// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1teGp","inputDescription":"styles_inputDescription__1XYCq"};